export default __webpack_public_path__ + "assets/images/640c189f04ba8e6bf75f2ab80c7a0d55.jpg";